import CanalModel from './CanalModel'
import TiposDeCanaisEnum from './TiposDeCanaisEnum'

export default class CanalMetaMessengerModel extends CanalModel {
  constructor({
    id = 0,
    nome = '',
    descricao = '',
    identificadorPagina = '',
    tokenAcessoPagina = '',
  } = {}) {
    super(id, nome, descricao, TiposDeCanaisEnum.MetaMessenger)
    this.identificadorPagina = identificadorPagina
    this.tokenAcessoPagina = tokenAcessoPagina
  }
}
